import { useEffect, useState } from 'react';
import { getConfiguration } from '@sas/nova-core/config';
import { useMounted } from '../../hooks/useMounted';
export const useConfig = function () {
  const [config, setConfig] = useState(null);
  const mounted = useMounted();
  useEffect(() => {
    getConfiguration().then(config => {
      if (!mounted.current) return;
      setConfig(config);
    });
  }, [mounted]);
  return config;
};
//# sourceMappingURL=useConfig.js.map